import { render, staticRenderFns } from "./rate-oms.vue?vue&type=template&id=1917a66c"
import script from "./rate-oms.vue?vue&type=script&lang=ts"
export * from "./rate-oms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports